import React, { useState, useRef, useEffect } from "react";
import styles from "../weight.module.css";
import { TextField } from "@mui/material";
import DividerLine from "ui/crfs/divider_line";
import Radio from "@mui/material/Radio";
import { cloneDeep } from "lodash";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";

export default function WeightUI(props) {
  const {
    key_id,
    field,
    title,
    options,
    sub_title,
    uval,
    onUpdate,
    crf_id,
    field_id,
    query,
    setQuery,
    subject_id,
    domain_id,
    calcUpdateToCrfStatus,
    enableQuery,
    show_checkmark,
    length,
    units,
    placeHolder,

    setParentFieldError,
    item_specific_error_validator,
    onChange,
    value,
    unit,
    type,
  } = props;

  const ref = useRef(null);

  const onKeyDown = (key) => {
    if (key.keyCode === 13) {
      ref.current.blur();
    }
  };

  const updateValue = (value_obj) => {
    // if (crfStatus === "data_complete") {
    //   setShowingCompleteChangeModal(true);
    //   return;
    // }
    if (field.value_name) {
      value_obj.value_name = field.value_name;
    }
    if (field.value2_name) {
      value_obj.value2_name = field.value2_name;
    }
    if (field.value3_name) {
      value_obj.value3_name = field.value3_name;
    }

    onUpdate(value_obj);
  };

  const onRadioChange = (key, input) => {
    if (key === "unit") {
      onChange("value2", input, true);
    } else {
      onChange("value3", input, true);
    }
    // updateValue(obj);
    // setValueObj(obj);
    // if (is_error(obj)) {
    //   setParentFieldError && setParentFieldError(key_id, true);
    // } else {
    //   setParentFieldError && setParentFieldError(key_id, false);
    // }
  };

  const onBlur = () => {
    onUpdate();
  };

  const is_error = () => {
    if (!value || value.length === 0) {
      setParentFieldError && setParentFieldError(key_id, true);
    }
    if (value?.length > 0) {
      let local_validation = () => !/^[0-9]{2,3}$/.test(value);
      let error = local_validation();
      if (item_specific_error_validator && item_specific_error_validator.constructor === Function) {
        error = local_validation() || item_specific_error_validator({ value, value2: unit });
      }
      setParentFieldError && setParentFieldError(key_id, error);
      return error;
    }
  };

  return (
    <React.Fragment>
      <React.Fragment>
        <div className={styles.row}>
          <div className={styles.label}>Value</div>
          <TextField
            type="text"
            inputRef={ref}
            placeholder={placeHolder || ""}
            value={value}
            onChange={(e) => {
              let value = e.target.value;
              if (/^([0-9]+){0,3}$/.test(value)) {
                onChange("value", value);
              }
              // if (is_error({ ...valueObj, value })) {
              //   setParentFieldError && setParentFieldError(key_id, true);
              // } else {
              //   setParentFieldError && setParentFieldError(key_id, false);
              // }
            }}
            inputProps={{ maxLength: 3 }}
            autoComplete="off"
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            sx={{
              "& .MuiInputBase-input": {
                padding: "5px",
                textAlign: "center",
                width: "50px",
                fontSize: 14,
              },
            }}
            error={is_error()}
          />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Unit</div>
          <div className={styles.radio_group}>
            <div
              className={styles.radio_item_wrapper}
              onClick={() => {
                onRadioChange("unit", "kg");
              }}
            >
              <Radio
                size="small"
                checked={unit === "kg"}
                onChange={(e) => {
                  if (e.target.checked) onRadioChange("unit", "kg");
                }}
                sx={{
                  padding: "0px",
                  marginRight: "4px",
                }}
              />
              <div className={styles.radio_text}>kg</div>
            </div>{" "}
            <div className={styles.radio_item_wrapper} onClick={() => onRadioChange("unit", "lbs")}>
              <Radio
                size="small"
                checked={unit === "lbs"}
                onChange={(e) => {
                  if (e.target.checked) onRadioChange("unit", "lbs");
                }}
                sx={{
                  padding: "0px",
                  marginRight: "4px",
                }}
              />
              <div className={styles.radio_text}>lbs</div>
            </div>
          </div>
        </div>
        {!field.exclude_actual_or_estimate ? (
          <div className={styles.row}>
            <div className={styles.label}>Measurement Type</div>
            <div className={styles.radio_group}>
              <div
                className={styles.radio_item_wrapper}
                onClick={() => {
                  onRadioChange("accuracy", "estimate");
                }}
              >
                <Radio
                  size="small"
                  checked={type === "estimate"}
                  onChange={(e) => {
                    if (e.target.checked) onRadioChange("accuracy", "estimate");
                  }}
                  sx={{
                    padding: "0px",
                    marginRight: "4px",
                  }}
                />
                <div className={styles.radio_text}>Estimate</div>
              </div>{" "}
              <div
                className={styles.radio_item_wrapper}
                onClick={() => {
                  onRadioChange("accuracy", "actual");
                }}
              >
                <Radio
                  size="small"
                  checked={type === "actual"}
                  onChange={(e) => {
                    if (e.target.checked) onRadioChange("accuracy", "actual");
                  }}
                  sx={{
                    padding: "0px",
                    marginRight: "4px",
                  }}
                />
                <div className={styles.radio_text}>Actual</div>
              </div>
            </div>
          </div>
        ) : null}
        {units ? <div className={styles.input_description}>{units}</div> : null}
        {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
      </React.Fragment>
    </React.Fragment>
  );
}
